import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from '@material-ui/core';

const DateRangeSelector = ({ isOpen, onClose, onSubmit }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Select date range for report...</DialogTitle>
      <DialogContent>
        <TextField
          id="start"
          label="Start Date"
          type="date"
          name="start"
          InputLabelProps={{
            shrink: true,
          }}
          style={{ padding: '8px' }}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <TextField
          id="end"
          label="End Date"
          type="date"
          name="end"
          InputLabelProps={{
            shrink: true,
          }}
          style={{ padding: '8px' }}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => onSubmit(startDate, endDate, onClose)}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DateRangeSelector;
